'use client';

import { Map, X, Building2 } from 'lucide-react';
import type { City } from '@/hooks/useCities';

interface QuickCompareCitiesProps {
  cities: City[];
  selectedCities: City[];
  onCitySelect: (city: City) => void;
  onRemoveCity: (cityId: string) => void;
  onCompare: () => void;
  onClear: () => void;
}

export default function QuickCompareCities({ 
  cities, 
  selectedCities, 
  onCitySelect, 
  onRemoveCity, 
  onCompare, 
  onClear 
}: QuickCompareCitiesProps) {



  return (
    <div className="bg-gradient-to-r from-sky-50 to-blue-50 border border-sky-200 rounded-lg p-6">
      <div className="flex items-center gap-2 mb-4">
        <Building2 className="h-5 w-5 text-sky-600" />
        <h2 className="text-xl font-semibold text-slate-900">Compare Cities True Size</h2>
      </div>
      
      <p className="text-sm text-slate-600 mb-4">
        Choose any two cities from the list below to compare their true sizes on an interactive map.
      </p>


      {/* 已选择的城市 */}
      {selectedCities.length > 0 && (
        <div className="mb-4">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm font-medium text-slate-700">Selected Cities:</span>
            <button
              onClick={onClear}
              className="text-xs text-slate-500 hover:text-slate-700 flex items-center gap-1"
            >
              <X className="h-3 w-3" />
              Clear
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {selectedCities.map((city) => (
              <div
                key={city.id}
                className="flex items-center gap-2 bg-white border border-slate-200 rounded-md px-3 py-1.5 text-sm"
              >
                <div 
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: city.color }}
                />
                <span className="text-slate-700">{city.name}</span>
                <button
                  onClick={() => onRemoveCity(city.id)}
                  className="text-slate-400 hover:text-slate-600"
                >
                  <X className="h-3 w-3" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}


      {/* 比较按钮 */}
      <div className="flex flex-col gap-2">
        <button
          onClick={onCompare}
          disabled={selectedCities.length !== 2}
          className={`flex items-center justify-center gap-2 px-4 py-3 rounded-md text-sm font-medium transition-all ${
            selectedCities.length === 2
              ? 'bg-sky-600 text-white hover:bg-sky-700 shadow-md'
              : 'bg-slate-200 text-slate-400 cursor-not-allowed'
          }`}
        >
          <Map className="h-4 w-4" />
          Compare on Map
        </button>
      </div>
    </div>
  );
}
